const FEATUREFLAG_SELF_REGISTRATION = 'FEATUREFLAG_SELF_REGISTRATION'

export { FEATUREFLAG_SELF_REGISTRATION }
